<template>
  <div class="container-fluid">
    <core v-if="accessGranted && !loader"/>
    <login v-if="!accessGranted && !loader"/>
    <loader v-if="loader"/>
    <div class="alert-container">
      <div
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
        v-for="error in errors"
        :key="error.key"
      >
        <i class="fas fa-exclamation-triangle fa-lg"></i>
        <span>{{error.message}}</span>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Login from "./components/Login";
import Core from "./components/Core";
import Loader from "./components/Loader";

import endpoints from "./endpoints";

export default {
  name: "App",
  data() {
    return {
      accessGranted: false,
      loader: true,
      errors: []
    };
  },
  methods: {
    checkToken: function() {
      this.loader = true;

      if (localStorage.token) {
        axios
          .get(endpoints.check, {
            headers: {
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(() => {
            this.accessGranted = true;
            this.loader = false;
          })
          .catch(() => {
            this.accessGranted = false;
            this.loader = false;
          });
      } else {
        this.accessGranted = false;
        this.loader = false;
      }
    },
    addErrorMessage: function(error) {
      this.errors.push({ key: this.errors.lenght, message: error });
    },
    refresh: function() {
      this.errors = [];
      this.checkToken();
    }
  },
  mounted: function() {
    this.refresh();
  },
  components: {
    Login,
    Core,
    Loader
  }
};
</script>

<style scoped>
.alert-container {
  position: fixed;
  margin-top: 1rem;
  margin-right: 1rem;
  top: 0;
  right: 0;
}
</style>

